let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hyqM1")).then(() => parcelRequire('35wYa'));